<template>
  <div class="row">
    <div class="col-12">
      <div class="p-1 col-md-6 col-12">
        <b-input-group>
          <b-form-input v-model="keyword" class="d-inline-block" placeholder="Nhập nội dung..."
            @keyup.enter="excellentSearchQuery" />
          <b-input-group-append>
            <b-button variant="danger" @click="excellentSearchQuery">
              <feather-icon icon="SearchIcon" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <div class="col-12">
      <b-table ref="refListTable" :items="itemsData" responsive :fields="tableColumns" primary-key="id" show-empty
        empty-text="Không tìm thấy bản ghi nào">
        <template #cell(excellent)="data">
          <b-form-checkbox :checked="dataRelate_ids.includes(data.item.id) ? true : false" class="custom-control-success"
            name="check-button" switch @input="updateStatus(data.item)" />
        </template>
      </b-table>
    </div>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
        class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-col>
  </div>
</template>
<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BLink, BFormCheckbox,
  BPagination, BInputGroupAppend, BInputGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, watch, computed,
} from '@vue/composition-api'
import store from '@/store'
import useJwt from '@/auth/jwt/useJwt';
import { showToast } from '@/@core/utils/utils';
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BPagination,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    vSelect,
  },
  props: {
    relate_ids: Array
  },
  setup(props, context) {
    const refListTable = ref(null)
    const dataUser = useJwt.getUser();
    const tableColumns = [
      { key: 'title', sortable: false, label: 'Tiêu đề' },
      { key: 'published_at', sortable: false, label: 'Ngày xuất bản', class: 'created_at', },
      { key: 'excellent', sortable: false, label: '', thAttr: { width: '12%' }, class: 'text-center' },
    ];

    const perPage = ref(10)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const type = ref('')
    const keyword = ref('')
    const itemsData = ref([]);
    const from = ref(0)
    const to = ref(0)
    const dataRelate_ids = ref([]);
    if (props.relate_ids.length > 0) {
      props.relate_ids.forEach((item) => {
        dataRelate_ids.value.push(item.id);
      });
    }

    const fetchAll = (isPaginate) => {
      isPaginate = isPaginate === undefined ? 0 : isPaginate;
      if (!isPaginate) {
        loading.value = true
      }
      store.dispatch('article/fetchAll', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        type: type.value,
        card_type: 'relate',
        isPaginate
      })
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            if (isPaginate) {
              from.value = result.data.from;
              to.value = result.data.to;
              total.value = result.data.total;
            } else {
              itemsData.value = result.data.data
              //total.value = result.data.total;
              setTimeout(() => {
                fetchAll(1);
              }, 1000);
            }
          }
        })
    }
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: from.value,
        to: to.value,
        of: total.value,
      }
    })

    watch([currentPage, perPage, searchQuery], () => {
      refetchData()
    })

    const refetchData = () => {
      fetchAll()
    }

    const excellentSearchQuery = () => {
      searchQuery.value = keyword.value
    }

    fetchAll()
    return {
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      excellentSearchQuery,
      keyword,
      itemsData,
      dataUser,
      dataRelate_ids
    }
  },
  methods: {
    updateStatus(item) {
      this.$emit("updateRelate", item)
    }
  },
}
</script>
<style lang="scss">
#modalState {
  .modal-dialog {
    max-width: 70% !important;
  }
}
</style>